import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PageOption } from "./PageOption";
import './Pagination.css'

export default function Pagination(props: {
    lineNum: number,
    records: number,
    pageNo: number,
    pageCount: number,
    onLineNumChange: (lines: number) => void
    onPageChange: (option: PageOption) => void
    id?: string
}) {

    return (
        <div className="pageination">
            <div className="float-left form-inline">
                <div className=" form-group">
                    <label htmlFor={props.id + "_linesPerPage"}><FormattedMessage id="records_per_page" description="record in page" defaultMessage="page records"/></label>
                    <input
                        className="form-control"
                        type="number"
                        id={props.id + "_linesPerPage"}
                        defaultValue={props.lineNum}
                        onBlur={e => {
                            if (Number(e.target.value) < 1) {
                                e.target.value = "1";
                                props.onLineNumChange(1);
                                return;
                            }
                            if (Number(e.target.value) > 200) {
                                e.target.value = "200";
                                props.onLineNumChange(200);
                                return;
                            }
                            props.onLineNumChange(Number(e.target.value));
                        }}
                        onKeyDown={e => {
                            if (e.key === "Enter") {
                                if (Number(e.currentTarget.value) < 1) {
                                    e.currentTarget.value = "1";
                                    props.onLineNumChange(1);
                                    return;
                                }
                                if (Number(e.currentTarget.value) > 200) {
                                    e.currentTarget.value = "200";
                                    props.onLineNumChange(200);
                                    return;
                                }
                                props.onLineNumChange(Number(e.currentTarget.value));
                            }
                        }}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor={props.id + "_sum"}><FormattedMessage id="records" description="records" defaultMessage="records"/></label>
                    <input className="form-control" type="number" id={props.id + "_sum"} disabled={true} value={props.records} />
                </div>
                <div className="form-group">
                    <label htmlFor={props.id + "_pageSum"}><FormattedMessage id="page_count" description="page count" defaultMessage="page count"/></label>
                    <input className="form-control" type="number" id={props.id + "_pageSum"} disabled={true} value={props.pageCount} />
                </div>
                <div className="form-group">
                    <label htmlFor="pageNo"><FormattedMessage id="page_no" description="page no" defaultMessage="page No."/></label>
                    <input className="form-control" type="number" id="pageNo" disabled={true} value={props.pageNo} />
                </div>
            </div>

            <div className="float-right">
                <button
                    className="btn btn-primary"
                    disabled={props.pageNo <= 1}
                    onClick={() => props.onPageChange(PageOption.first)}>
                    <FormattedMessage id="first_page" description="first page" defaultMessage="first"/>
                </button>

                <button
                    className="btn btn-primary"
                    disabled={props.pageNo <= 1}
                    onClick={() => props.onPageChange(PageOption.pre)}>
                    <FormattedMessage id="per_page" description="per page" defaultMessage="per"/>
                </button>

                <button
                    className="btn btn-primary"
                    disabled={props.pageNo >= props.pageCount}
                    onClick={() => props.onPageChange(PageOption.next)}>
                    <FormattedMessage id="next_page" description="next page" defaultMessage="next"/>
                </button>


                <button
                    className="btn btn-primary"
                    disabled={props.pageNo >= props.pageCount}
                    onClick={() => props.onPageChange(PageOption.last)}>
                    <FormattedMessage id="last_page" description="last page" defaultMessage="last"/>
                </button>
            </div>
        </div>)
}